import request from '@/utils/request'

/**
 * 查询员工列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function listStaffs(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.listStaffs',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 选择员工
 * @param {Object} data 员工数据
 * @returns {Promise} Promise对象
 */
export function chooseStaff(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/system.chooseStaff',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}